module.exports = __webpack_public_path__ + "static/media/piper-schedule.b9a21ce6.svg";